import { InputErrorMessage } from '@savvy-kit/components/input-error-message';
import { Label } from '@savvy-kit/components/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@savvy-kit/components/select';

type SelectFieldOption = {
  readonly value: string;
  readonly label: string;
};

type AddAccountSelectFieldProps = {
  readonly id: string;
  readonly label: string;
  readonly value: string;
  readonly options: readonly SelectFieldOption[];
  readonly onValueChange: (value: string) => void;
  readonly placeholder?: string;
  readonly errorMessage?: string;
};

export function AddAccountSelectField({
  id,
  label,
  value,
  options,
  onValueChange,
  placeholder = 'Select…',
  errorMessage,
}: AddAccountSelectFieldProps) {
  return (
    <div>
      <Label htmlFor={id} className="pb-2">
        {label}
      </Label>
      <Select value={value} items={options} onValueChange={onValueChange}>
        <SelectTrigger
          id={id}
          className="w-full"
          aria-invalid={errorMessage !== undefined}
          aria-describedby={errorMessage === undefined ? undefined : `${id}-error`}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <span id={`${id}-error`}>
        <InputErrorMessage message={errorMessage} />
      </span>
    </div>
  );
}
